// contact.fetchers — the funnel's first step on the wire.

import {
  BFF_ROUTES,
  LeadContactResponseSchema,
  type LeadContactRequest,
  type LeadContactResponse,
} from '@rheora/enrollment-contract';

import { bffPost } from './bff-client';

/**
 * `POST /bff/contact` — record the lead before any meter is known.
 *
 * `bffPost` already carries the session cookie and the captcha token, and the
 * route is captcha-gated like the lookups, so there is nothing extra to pass
 * here. The caller must have minted the session first (the panel does).
 */
export async function postLeadContact(
  request: LeadContactRequest,
): Promise<LeadContactResponse> {
  return bffPost(BFF_ROUTES.contact, request, LeadContactResponseSchema);
}
